import React from 'react';
import {connect} from 'react-redux';
import strings from '../../utils/strings';
import classNames from 'classnames';
import {updateObject} from '../../utils/reducerUtils';

import AudioPlayer from '../../components/AudioPlayer';
import FinishSound from '../../components/FinishSound';

import {VARIATION} from '../../constants';
const assignments = [];
var isPlaying = true;
const maxAudioPlayCount = 12;
class Test extends React.Component {
	constructor() {
		super();
		const variation = VARIATION;
		const language = strings.getLanguage();
		const audioFiles =
			language === 'de'
				? require(
						`../../assets/testdata/${'adult'}/${language}/dictation-audio-tutorial`
					).default
				: null;

		const presStartSound =
			language === 'de'
				? require(
						`../../assets/sounds/${'adult'}/${language}/SCR-A-007.mp3`
					)
				: null;
		this.audioFiles = audioFiles;
		this.presStartSound = presStartSound;
		const results = {};
		this.inputRefs = {};

		if (variation === 'adult' && (language === 'se' || language === 'de')) {
			for (let i = 1; i <= 2; i++) {
				//This count may be dependent on the test type
				assignments.push({id: i, value: ''});
			}
		}

		for (const assignment of assignments) {
			results[assignment.id] = assignment.value;
		}

		this.state = {
			results,
			disabledAssignments: {},
			audioPlayCounts: {},
			renderFinalSound: null,
		};
	}
	setResults(id, value, ev) {
		if (ev && ev.key === 'Enter') {
			this.focusNextAssignment(id);
		}
		if (value.length > 2) {
			const {results} = this.state;

			this.setState({
				results: updateObject(results, {
					[id]: value,
				}),
			});
		}
	}
	focusNextAssignment(assignmentId) {
		const currentIndex = assignments.findIndex(
			(assignment) => assignment.id === assignmentId
		);

		if (currentIndex < 0) {
			return;
		}

		const nextAssignment = assignments[currentIndex + 1];

		if (!nextAssignment) {
			return;
		}

		const nextInput = this.inputRefs[nextAssignment.id];

		if (nextInput && !nextInput.disabled) {
			nextInput.focus();
		}
	}
	getDisabledAssignments() {
		const {results} = this.state;

		const disabledAssignments = {};
		for (let i = 0; i < assignments.length; i++) {
			const assignmentId = assignments[i].id;
			if (results[assignmentId]) {
				disabledAssignments[assignmentId] = true;
			}
		}
		return disabledAssignments;
	}
	render() {
		const {onNextStep, refs} = this.props;

		const {
			audioPlayCounts,
			disabledAssignments,
			results,
			renderFinalSound,
		} = this.state;

		const allResultsHasValues = Object.keys(results).every(
			(key) => results[key]
		);

		const lastAudioRefs = null;
		const isNextButtonVisible = allResultsHasValues || !this.audioFiles;
		return (
			<div>
				<div className="lit-wrapper--thin lit-test lit-diktat">
					{assignments.map((assignment) => {
						const assignmentId = assignment.id;
						let lastRow = false;
						if (assignmentId === 2) {
							lastRow = true;
						}
						const audioFile = this.audioFiles[assignmentId];
						const assignmentAudioPlayCount =
							audioPlayCounts[assignmentId] || 0;
						const isDisabled = disabledAssignments[assignmentId];
						const isAudioDisabled =
							isDisabled ||
							assignmentAudioPlayCount === maxAudioPlayCount;

						let audioPlayerRef;
						return (
							<div
								className={classNames(
									'lit-input lit-revealed',
									{
										'lit-input--disabled': isDisabled,
									}
								)}
								key={assignmentId}
							>
								<AudioPlayer
									disabled={isAudioDisabled}
									id={assignmentId}
									onPause={() => {
										if (lastRow) {
											this.setState({
												renderFinalSound: true,
											});
										}
									}}
									onStart={() => {
										isPlaying = true;
										this.setState({
											audioPlayCounts: updateObject(
												audioPlayCounts,
												{
													[assignmentId]:
														assignmentAudioPlayCount +
														1,
												}
											),
										});
									}}
									ref={(ref) => {
										audioPlayerRef = ref;
									}}
									refs={refs}
									src={audioFile}
								/>
								<input
									className="lit-input__field"
									disabled={isDisabled}
									onChange={(ev) => {
										if (isDisabled) {
											return;
										}
										const value = ev.target.value;
										this.setResults(assignmentId, value);
									}}
									onKeyDown={(ev) => {
										const value = ev.target.value;
										this.setResults(
											assignmentId,
											value,
											ev
										);
									}}
									ref={(ref) => {
										this.inputRefs[assignmentId] = ref;
									}}
									onFocus={() => {
										const disabledAssignments =
											this.getDisabledAssignments();
										disabledAssignments[assignmentId] =
											false;

										if (assignmentAudioPlayCount === 0) {
											audioPlayerRef.handleStartPlayer();
										}

										this.setState({
											disabledAssignments,
										});
									}}
									placeholder={strings.writeWordHere}
									spellCheck={false}
									autoComplete="off"
									autoCorrect="off"
									autoCapitalize="off"
									type="text"
								/>
							</div>
						);
					})}
				</div>

				<br></br>
				{isNextButtonVisible && renderFinalSound && (
					<div>
						<span>
							<FinishSound
								renderFinalSound={this.state.renderFinalSound}
								text={
									'Tippen Sie auf Start, um mit der Aufgabe zu beginnen.'
								}
								audioSrc={this.presStartSound}
							/>

							<button
								className="lit-btn lit bg-primary"
								onClick={() => onNextStep(results)}
							>
								{strings.start}
							</button>
						</span>
					</div>
				)}
			</div>
		);
	}
}

const mapStateToProps = () => {
	return {};
};

export default connect(mapStateToProps)(Test);
